import protoRoot from "../proto-root";

const name = "startVideoRecordingRPCResponse";

function create({ result, recordingLimit }) {
  const StartVideoRecording = protoRoot.lookupType(
    "comm.StartVideoRecordingRPCResponse"
  );

  const Result = StartVideoRecording.lookupEnum("Result");

  const response = StartVideoRecording.create({
    result: Result.values[result],
    recordingLimit
  });
  return { payload: response, name };
}

export default {
  create,
  name
};

// message StartVideoRecordingRPCResponse {
//     enum Result {
//         SUCCESS = 0;
//         ALREADY_RUNNING = 1;
//     }
//     Result result = 1;
//     int64 recordingLimit = 2;
// }
